module.exports = __webpack_public_path__ + "img/pa.052ef0c9.svg";